import { rem } from "polished";
import styled, { css } from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const Wrapper = withViewportStyle("div")<{
  $backgroundImage?: string;
  backgroundPosition?: ImagePosition;
  imageFit?: ImageFit;
}>`
  display: grid;
  gap: ${rem(16)};

  ${({ $backgroundImage, imageFit }) =>
    $backgroundImage &&
    css`
      position: relative;
      background: rgba(0, 0, 0, 0.8);
      background-image: url(${$backgroundImage});
      background-size: ${imageFit || "cover"};
      background-repeat: no-repeat;
      background-position: center;
      height: 100%;
    `}

  ${(props) =>
    props.backgroundPosition &&
    css`
      background-position: ${props.backgroundPosition};
    `}

  padding: ${rem(180)} ${rem(100)};
  min-height: ${rem(660)};

  .text-primitive {
    text-align: center;
    color: #ffffff;
  }

  .text-primitive.headingOne {
    max-width: ${rem(1016)};
    margin: 0 auto;
  }

  .text-primitive.paragraph {
    max-width: ${rem(808)};
    margin: 0 auto;
  }

  ${(props) =>
    props.$viewport.tablet`
      padding: ${rem(100)};
      min-height: ${rem(496)};
    `}

  ${(props) =>
    props.$viewport.mobile`
      padding: ${rem(140)} ${rem(16)};
      min-height: ${rem(575)};
    `}
`;

export const LogoContainer = withViewportStyle("span")<{
  isLogoResized: boolean;
}>`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  > img {
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(120) : rem(40))};
    max-width: 100%;
    object-fit: contain;
    margin-bottom: ${rem(48)};

    ${(props) => props.$viewport.tablet`
      max-height: ${({ isLogoResized }) =>
        isLogoResized ? rem(100) : rem(35)};
    `}

    ${(props) => props.$viewport.mobile`
      max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(31))};
    `}
  }
`;

export const CTAWrapper = styled.div`
  margin: ${rem(8)} auto 0 auto;
`;

export const CTAButtonWrapper = styled.div`
  margin: ${rem(24)} auto 0 auto;
  max-width: ${rem(300)};
  display: flex;
  justify-content: center;
  width: fit-content;
`;

export const RichTextContainer = styled.div`
  display: grid;
  grid-gap: ${rem(16)};
  max-width: ${rem(1016)};
  margin: 0 auto;

  .default .ck-content h1,
  .default .ck-content h2,
  .default .ck-content h3,
  .default .ck-content h4,
  .default .ck-content h5,
  .default .ck-content p,
  .default .ck-content li {
    margin: 0;
    color: #fff;
  }
`;
